export default __webpack_public_path__ + "static/media/bhojpuri_cm_1.28b2404e.mp3";